
  <h2 class="section-title-with-icon">
    <mat-icon svgIcon="project_info" class="section-title-icon notranslate"></mat-icon>
    <span>Project Information</span>
  </h2>
  <ul class="details-list">
    <!-- Original project budget -->
    <li *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && holdingAsAsset.plannedCostsToDate != undefined">
      <label>Original Project Budget</label>
      <span>
        <span class="value">{{ holdingAsAsset.plannedCostsToDate | terraCurrency }} </span>
        <span class="unit">{{ holdingAsAsset.initialCurrency.iso }}</span>
      </span>
    </li>
    <!-- Revised project budget -->
    <li *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && holdingAsAsset.actualCostsToDate != undefined">
      <label>Revised Project Budget</label>
      <span>
        <span class="value">{{ holdingAsAsset.actualCostsToDate | terraCurrency }} </span>
        <span class="unit">{{ holdingAsAsset.initialCurrency.iso }}</span>
      </span>
    </li>
    <!-- Construction start date -->
    <li *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && holdingAsAsset.constructionStartDate != undefined">
      <label>Construction Start Date</label>
      <span>
        <span class="value">{{ holdingAsAsset.constructionStartDate | date }}</span>
      </span>
    </li>
    <!-- Construction end date -->
    <li *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && holdingAsAsset.constructionEndDate != undefined">
      <label>Construction End Date</label>
      <span>
        <span class="value">{{ holdingAsAsset.constructionEndDate | date }}</span>
      </span>
    </li>

    <!-- From original project budget -->
    <ng-container *ngIf="holding.projectBudgetOriginal as budget">
      <li *ngIf="budget.acquisition != undefined">
        <label>Acquisition</label>
        <span>
          <span class="value">{{ budget.acquisition | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>
      <li *ngIf="budget.hardCost != undefined">
        <label>Hard Cost</label>
        <span>
          <span class="value">{{ budget.hardCost | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>
      <li *ngIf="budget.softCost != undefined">
        <label>Soft Cost</label>
        <span>
          <span class="value">{{ budget.softCost | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>
      <li *ngIf="budget.financing != undefined">
        <label>Financing</label>
        <span>
          <span class="value">{{ budget.financing | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>
      <li *ngIf="budget.totalCosts != undefined">
        <label>Total Costs</label>
        <span>
          <span class="value">{{ budget.totalCosts | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>
      <li *ngIf="holding.discriminator === HoldingDiscriminator.Asset && budget.totalCostsPerGrossAreaUnit != undefined">
        <label>Total Costs per Gross {{ holdingAsAsset.areaUnits | enumString : AreaUnit}}</label>
        <span>
          <span class="value">{{ budget.totalCostsPerGrossAreaUnit | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>
      <li *ngIf="holding.discriminator === HoldingDiscriminator.Asset && budget.totalCostsPerNetAreaUnit != undefined">
        <label>Total Costs per Net {{ holdingAsAsset.areaUnits | enumString : AreaUnit}}</label>
        <span>
          <span class="value">{{ budget.totalCostsPerNetAreaUnit | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>
    </ng-container>
  </ul>
